/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetStationChainResponse,
  ListRequest,
  ListResponseOfStationChainListItem,
  StationChainWriteRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const createProductsStationChain = (
    stationChainWriteRequest: StationChainWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/products/station-chains`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stationChainWriteRequest, signal
    },
      );
    }
  


export const getCreateProductsStationChainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsStationChain>>, TError,{data: StationChainWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProductsStationChain>>, TError,{data: StationChainWriteRequest}, TContext> => {

const mutationKey = ['createProductsStationChain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductsStationChain>>, {data: StationChainWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createProductsStationChain(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProductsStationChainMutationResult = NonNullable<Awaited<ReturnType<typeof createProductsStationChain>>>
    export type CreateProductsStationChainMutationBody = StationChainWriteRequest
    export type CreateProductsStationChainMutationError = ErrorType<unknown>

    export const useCreateProductsStationChain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductsStationChain>>, TError,{data: StationChainWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductsStationChain>>,
        TError,
        {data: StationChainWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateProductsStationChainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const productsStationChainList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfStationChainListItem>(
      {url: `/api/products/station-chains/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getProductsStationChainListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsStationChainList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof productsStationChainList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['productsStationChainList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof productsStationChainList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  productsStationChainList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProductsStationChainListMutationResult = NonNullable<Awaited<ReturnType<typeof productsStationChainList>>>
    export type ProductsStationChainListMutationBody = ListRequest
    export type ProductsStationChainListMutationError = ErrorType<unknown>

    export const useProductsStationChainList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof productsStationChainList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof productsStationChainList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getProductsStationChainListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateProductsStationChain = (
    id: string,
    stationChainWriteRequest: StationChainWriteRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/station-chains/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: stationChainWriteRequest
    },
      );
    }
  


export const getUpdateProductsStationChainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsStationChain>>, TError,{id: string;data: StationChainWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProductsStationChain>>, TError,{id: string;data: StationChainWriteRequest}, TContext> => {

const mutationKey = ['updateProductsStationChain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductsStationChain>>, {id: string;data: StationChainWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductsStationChain(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductsStationChainMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductsStationChain>>>
    export type UpdateProductsStationChainMutationBody = StationChainWriteRequest
    export type UpdateProductsStationChainMutationError = ErrorType<unknown>

    export const useUpdateProductsStationChain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductsStationChain>>, TError,{id: string;data: StationChainWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductsStationChain>>,
        TError,
        {id: string;data: StationChainWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateProductsStationChainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getProductsStationChain = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetStationChainResponse>(
      {url: `/api/products/station-chains/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProductsStationChainQueryKey = (id?: string,) => {
    return [
    `/api/products/station-chains/${id}`
    ] as const;
    }

    
export const getGetProductsStationChainQueryOptions = <TData = Awaited<ReturnType<typeof getProductsStationChain>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationChain>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsStationChainQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsStationChain>>> = ({ signal }) => getProductsStationChain(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsStationChain>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsStationChainQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsStationChain>>>
export type GetProductsStationChainQueryError = ErrorType<void>


export function useGetProductsStationChain<TData = Awaited<ReturnType<typeof getProductsStationChain>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationChain>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsStationChain>>,
          TError,
          Awaited<ReturnType<typeof getProductsStationChain>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsStationChain<TData = Awaited<ReturnType<typeof getProductsStationChain>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationChain>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductsStationChain>>,
          TError,
          Awaited<ReturnType<typeof getProductsStationChain>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductsStationChain<TData = Awaited<ReturnType<typeof getProductsStationChain>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationChain>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductsStationChain<TData = Awaited<ReturnType<typeof getProductsStationChain>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductsStationChain>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsStationChainQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteProductsStationChain = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/products/station-chains/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductsStationChainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsStationChain>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductsStationChain>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteProductsStationChain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductsStationChain>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductsStationChain(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductsStationChainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductsStationChain>>>
    
    export type DeleteProductsStationChainMutationError = ErrorType<unknown>

    export const useDeleteProductsStationChain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductsStationChain>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductsStationChain>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductsStationChainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    